<div>

  <div class="nav-under container-fluid header-borders border-bottom py-2">
    <nav aria-label="breadcrumb" class="row">
      <div class="col-md-10">
        <ol class="breadcrumb bg-white page-title" style="margin-bottom: 0;">
          <li class="breadcrumb-item ">App Content</li>
          <li class="breadcrumb-item active" aria-current="page">Videos</li>
        </ol>
      </div>
    </nav>
  </div>

  <div class="container-fluid">
    <div class="py-2" *ngIf="!isLoadingVideos">
      <div class="row">
        <div class="col-md-auto col-12">
          <div class="h-100 d-flex align-items-center ">
          <h3 class="page-subtitle">Videos</h3>
          <button
            type="button"
            class="btn btn-primary btn-sm ml-3"
            data-toggle="modal"
            data-target="#addVideoModal"
          >
            Add Video
          </button>
          </div>
        </div>
        <div class="col">

        </div>
        <div class="col-md-3">
          <div class="searchbox">
            <input
              class="form-control"
              type="text"
              name="searchVideos"
              placeholder="Search videos"
              (keyup)="filterVideos($event)"
            />
            <span class="fa fa-search"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="spinner d-block w-100 py-5 text-center" *ngIf="isLoadingVideos">
      <span class="spinner-border spinner-border-md mx-auto" role="status"></span>
    </div>
    <div *ngIf="!isLoadingVideos">
      <div *ngIf="videosData?.length===0" style="text-align: center;">
        No videos added yet...
      </div>
      <div *ngIf="videosData?.length>0">
        <table class="table table-bordered table-primary tab-data">
          <thead>
            <tr class="text-uppercase">
              <th>#</th>
              <th scope="col">Video</th>
              <th scope="col">Description</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of videosDataFilter | paginate: { itemsPerPage: count, currentPage: page };
            let i = index">
              <td>{{ (page - 1) * count + i + 1 }}</td>
              <td>
                <div class="d-flex">
                  <div>
                    <video width="300" height="150" controls muted>
                      <source src='{{ "https://storage.googleapis.com/ezyagric-media" + row.video_url }}'>
                      Your browser does not support the video tag.
                    </video>
                  </div>
                  <div class="ml-3">
                    <div><h5>{{row.title}}</h5></div>
                    <div>{{row.duration}}</div>
                  </div>
                </div>
              </td>
              <td [innerHTML]="row.description | truncateText:70"></td>
              <td>
                <div class="dropdown">
                  <button class="btn btn-outline-info dropdown-toggle" type="button" id="dropdownMenuButton"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    ACTION
                  </button>
                  <div class="dropdown-menu dropdown-menu-right options" aria-labelledby="dropdownMenuButton">
                    <button
                      class="dropdown-item suspend"
                      data-toggle="modal"
                      data-target="#editVideoModal"
                      (click)="setSingleVideoViewData(row, 'true')"
                    >
                      View details
                    </button>
                    <button
                      class="dropdown-item suspend text-danger"
                      data-toggle="modal"
                      data-target="#deleteVideoModal"
                      (click)="setSingleVideoViewData(row, 'false')"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="!isLoadingVideos">
          <nav>
            <pagination-controls (pageChange)="page = $event"></pagination-controls>
          </nav>
        </div>
      </div>
    </div>
  </div>

  <!-- Delete video modal-->
  <div class="modal fade" id="deleteVideoModal" tabindex="-1" role="dialog" aria-labelledby="deleteVideoModal"
  aria-hidden="true">
   <div class="modal-dialog modal-dialog-centered" role="document">
     <div class="modal-content" *ngIf="singleVideoData">
       <div class="modal-header no-border">
         <h5 class="modal-title text-primary">Delete Video</h5>
         <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close">
           <span aria-hidden="true">&times;</span>
          </button>
       </div>
       <div class="modal-body">
         Are you sure you want to delete <span class="font-weight-bold">"{{singleVideoData.title }}"</span> permanently?
       </div>
       <div class="modal-footer no-border">
         <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
         <button
           type="button"
           class="btn btn-danger"
           (click)="deleteVideo(singleVideoData.id)"
         >
           <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
           </span>
           <span *ngIf="loading" class="mx-2">Loading...</span>
           <span *ngIf="!loading">
              Delete
           </span>
         </button>
       </div>
     </div>
   </div>
  </div>

  <!-- Add video modal  -->
  <div class="modal fade" id="addVideoModal" style="overflow: auto;">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document" (click)="onClickOutside()">
      <div class="card modal-content container-fluid">
          <div class="modal-header no-border">
            <h5 class="modal-title text text-primary" style="font-weight: bold;" id="modal-basic-title">Add new video</h5>
            <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close" (click)="resetAddVideoModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div>
              <form
                class="form"
                #addVideoForm="ngForm"
                (ngSubmit)="addVideo(addVideoForm.value)"
                id="addVideoForm"
              >
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label for="video-input" id="upload-lab">Upload video</label>
                      <input
                        type="file"
                        class="form-control file-input"
                        id="video-input"
                        name="video"
                        (change)="processVideo($event)"
                        accept="video/*"
                        hidden
                      />
                      <span id="chosen-file">No file chosen</span>
                      <br>
                      <span style="font-size: 8pt;">*Video should not be more than 32mbs</span>
                    </div>
                    <div id="vid-progress">
                      <div class="placeholder video"></div>
                      <div class="progress">
                        <div
                          class="progress-bar progress-bar-info progress-bar-striped"
                          role="progressbar"
                          attr.aria-valuenow="{{ progress }}"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          [ngStyle]="{ width: progress + '%' }"
                        >
                          {{ progress }}%
                        </div>
                      </div>
                    </div>
                    <div id="video-display" style="display: none;">
                      <video id="add-video-tag" width="100%" height="225px" controls muted>
                        <source src='#' id="add-video-source">
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  </div>

                  <div class="col border-left">
                    <div class="form-group">
                      <label for="title">Video title</label>
                      <input
                        type="text"
                        class="form-control"
                        name="title"
                        #title="ngModel"
                        [(ngModel)]="model.title"
                        required
                      >
                      <div
                      *ngIf="title.touched && !title.valid"
                      class="text-danger error_message"
                      >
                        <span *ngIf="title.hasError('required')">
                          Please the title is required
                        </span>
                      </div>
                    </div>

                    <div class="form-group">
                      <label>Video description</label>
                      <quill-editor
                        name="description"
                        #description="ngModel"
                        [(ngModel)]="model.description"
                        [modules]="quillConfig"
                        [styles]="editorStyle"
                      >
                      </quill-editor>
                    </div>
                  </div>
                </div>
                <br>
                <div class="modal-footer no-border">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    (click)="resetAddVideoModal()"
                  >Cancel
                  </button>
                  <button
                    type="submit"
                    class="btn btn-primary float-right"
                    [disabled]="!addVideoForm.form.valid"
                  >
                  <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
                  </span>
                  <span *ngIf="loading" class="mx-2">Loading...</span>
                  <span *ngIf="!loading">
                    Submit
                  </span>
                  </button>
                </div>
              </form>
            </div>
          </div>
      </div>
    </div>
  </div>

  <!-- Edit video modal  -->
  <div class="modal fade" id="editVideoModal" style="overflow: auto;">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document" (click)="onClickOutside()">
      <div class="card modal-content container-fluid">
          <div class="modal-header no-border">
            <h5 class="modal-title text text-primary" style="font-weight: bold;" id="modal-basic-title">Edit video</h5>
            <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close" (click)="resetEditVideoModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div>
              <form
                *ngIf="singleVideoData"
                class="form"
                #editVideoForm="ngForm"
                (ngSubmit)="editVideo(editVideoForm.value)"
                id="editVideoForm"
              >
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <div class="mb-1">
                        <video id="edit-video-tag" width="100%" height="225px" controls muted>
                          <source
                            src='{{ "https://storage.googleapis.com/ezyagric-media" + singleVideoData.video_url }}'
                            id="edit-video-source"
                          >
                          Your browser does not support the video tag.
                        </video>
                      </div>
                      <div id="edit-vid-progress" style="display: none;">
                        <div class="progress">
                          <div
                            class="progress-bar progress-bar-info progress-bar-striped"
                            role="progressbar"
                            attr.aria-valuenow="{{ progress }}"
                            aria-valuemin="0"
                            aria-valuemax="100"
                            [ngStyle]="{ width: progress + '%' }"
                          >
                            {{ progress }}%
                          </div>
                        </div>
                      </div>
                      <label for="edit-vid-input" id="edit-upload-lab">Change video</label>
                      <input
                        type="file"
                        class="form-control file-input"
                        id="edit-vid-input"
                        name="video"
                        (change)="processVideo($event)"
                        accept="video/*"
                        hidden
                      />
                      <span id="file-chosen">No file chosen</span>
                      <br>
                      <span style="font-size: 8pt;">*Video should not be more than 32mbs</span>
                    </div>
                  </div>

                  <div class="col border-left">
                    <div class="form-group">
                      <label for="title">Video title</label>
                      <input
                        type="text"
                        class="form-control"
                        name="title"
                        #title="ngModel"
                        [(ngModel)]="singleVideoData.title"
                        required
                      >
                      <div
                      *ngIf="title.touched && !title.valid"
                      class="text-danger error_message"
                      >
                        <span *ngIf="title.hasError('required')">
                          Please the title is required
                        </span>
                      </div>
                    </div>

                    <div class="form-group">
                      <label>Video description</label>
                      <quill-editor
                        name="description"
                        #description="ngModel"
                        [(ngModel)]="singleVideoData.description"
                        [modules]="quillConfig"
                        [styles]="editorStyle"
                      >
                      </quill-editor>
                    </div>
                  </div>
                </div>
                <br>
                <div class="modal-footer no-border">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    (click)="resetEditVideoModal()"
                  >Cancel
                  </button>
                  <button
                    type="submit"
                    class="btn btn-primary float-right"
                    [disabled]="!editVideoForm.form.valid"
                  >
                  <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
                  </span>
                  <span *ngIf="loading" class="mx-2">Loading...</span>
                  <span *ngIf="!loading">
                    Save changes
                  </span>
                  </button>
                </div>
              </form>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
